import { Recipe, RecipeIngredient } from "../types/mes";

export interface RecipeBatchLine {
  key: string;
  name: string;
  kg: number;
}

export function getRecipeLineName(ing: RecipeIngredient): string {
  if (ing.ChildRecipe && ing.Recipe_RecipeToRecipeIngredient_ChildRecipe) {
    const sf = ing.Recipe_RecipeToRecipeIngredient_ChildRecipe.SemiFinishedProduct;
    return sf?.Name || ing.Recipe_RecipeToRecipeIngredient_ChildRecipe.RecipeCode || `Poluproizvod #${ing.ChildRecipe}`;
  }
  return ing.Ingredient_IngredientToRecipeIngredient?.IngredientName || `Sastojak #${ing.Ingredient ?? "?"}`;
}

/**
 * Top-level recipe lines (raw + semi-finished) with kg from final dough mass.
 */
export function recipeLinesForBatchDisplay(
  recipe: Recipe,
  doughMassKg: number
): RecipeBatchLine[] {
  const lines = recipe.RecipeIngredient_RecipeToRecipeIngredient_Recipe || [];
  const rows = lines
    .map((line, idx) => ({
      key: `line-${line.ID ?? idx}`,
      name: getRecipeLineName(line),
      bakerPct: Number(line.BakerPercentage) || 0,
    }))
    .filter((row) => row.bakerPct > 0);

  const totalPct = rows.reduce((s, row) => s + row.bakerPct, 0);
  if (totalPct <= 0 || doughMassKg <= 0) {
    return rows.map((row) => ({ key: row.key, name: row.name, kg: 0 }));
  }

  const flourBasisKg = (doughMassKg * 100) / totalPct;

  return rows.map((row) => ({
    key: row.key,
    name: row.name,
    kg: Math.round((row.bakerPct / 100) * flourBasisKg * 100) / 100,
  }));
}
